import { Button, ButtonProps, styled } from '@mui/material'
import { PropsWithChildren } from 'react'

type HeaderButtonProps = {
  type?: 'general' | 'banner'
  fullWidth?: boolean
} & ButtonProps

const CustomButton = styled(Button)<{ fullWidth?: boolean }>`
  height: 48px;
  flex: 1;
  max-width: 260px;
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  padding: 0 10px;
  border-radius: 10px;
  font-size: inherit;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 3px 0 0 #0000000d;

  ${({ fullWidth }) =>
    fullWidth &&
    `
    flex: 1;
  `}
`

function HeaderButton({
  children,
  type,
  ...rest
}: PropsWithChildren<HeaderButtonProps>) {
  return <CustomButton {...rest}>{children}</CustomButton>
}

export default HeaderButton
